import {useGlobalNats, useNotification} from '@component/nats/hooks/useNats'

const NatsInitializer = () => {
    useGlobalNats()
    useNotification()

    return null
}
export default NatsInitializer
